module.exports = __webpack_public_path__ + "img/dynamik-logo1.e9861d14.png";